export default __webpack_public_path__ + "static/media/2005.26ceacb4.png";